import React, { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

interface PropTypes extends ComponentProps<"input"> {
  label?: string;
  error?: string;
  isInvalid?: boolean;
  containerClassName?: string;
  rightContent?: React.ReactNode;
  outerClassName?: string;
  labelClassName?: string;
}

const Input = ({
  label,
  error,
  className,
  labelClassName,
  isInvalid = false,
  containerClassName,
  outerClassName,
  rightContent,
  ...rest
}: PropTypes) => {
  return (
    <div className={twMerge(containerClassName)}>
      {label ? (
        <div className="label flex-shrink-0 ">
          <span className={twMerge("label-text text-[1rem] lg:text-xs", labelClassName)}>{label}</span>
        </div>
      ) : null}

      <div
        className={twMerge(
          "join w-full rounded-lg border border-primary transition-all focus-within:ring-2 focus-within:ring-primary focus-within:border-primary",
          outerClassName
        )}
      >
        <input
          {...rest}
          className={twMerge(
            "input join-item h-10 w-full border-0 text-[1rem] lg:text-xs focus:outline-none rounded-lg",
            className
          )}
        />
        {rightContent ? (
          <div className="join-item h-10 flex items-center">
            {rightContent}
          </div>
        ) : null}

      </div>
      {isInvalid && error ? (
        <div className="label  -my-0.5">
          <span className="label-text-alt text-red-600">{error}</span>
        </div>
      ) : null}
    </div>
  );
};

export default Input;
